import { c as _c } from "react/compiler-runtime";
import { dateFromMintNumber, displayedEonNumberFromIndex, displayedEpochNumberFromIndex, displayedEraNumberFromIndex, displayedPeriodNumberFromIndex, displayedSeasonNumberFromIndex, displayedYearNumberFromIndex, getSeasonIndexForDate } from "@/components/meme-calendar/meme-calendar.helpers";
export default function MemeCalendarPeriods(t0) {
  const $ = _c(2);
  const {
    id
  } = t0;
  let t1;
  if ($[0] !== id) {
    const d = dateFromMintNumber(id);
    const idx = getSeasonIndexForDate(d);
    const eon = displayedEonNumberFromIndex(idx);
    const era = displayedEraNumberFromIndex(idx);
    const period = displayedPeriodNumberFromIndex(idx);
    const epoch = displayedEpochNumberFromIndex(idx);
    const year = displayedYearNumberFromIndex(idx);
    const szn = displayedSeasonNumberFromIndex(idx);
    const printPeriod = _temp;
    t1 = <div className="tw-text-xs sm:tw-text-sm tw-text-iron-300">{printPeriod("SZN", szn)} / {printPeriod("YEAR", year)} /{" "}{printPeriod("EPOCH", epoch)} / {printPeriod("PERIOD", period)} /{" "}{printPeriod("ERA", era)} / {printPeriod("EON", eon)}</div>;
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(label, number) {
  return <><span>{label}</span> <span className="tw-font-semibold">{number}</span></>;
}